if (!customElements.get('sticky-header')) {
  /*
    Naglowek jest PRZYPIETY DO EKRANU od pierwszego piksela przewijania.

    Poprzednia wersja trzymala go przy gorze DOKUMENTU (position: absolute) i dopiero
    po przewinieciu ponad jego wysokosc przelaczala na position: fixed. Skutkiem byla
    ucieczka naglowka razem z trescia w pierwszych ~56 px oraz widoczny przeskok w
    momencie zmiany trybu pozycjonowania. Teraz tryb sie nie zmienia - rusza sie
    wylacznie przesuniecie, wiec kazde przejscie jest plynne.

    Klasy:
      header--sticky  - naglowek odjechal od gory; steruje wygladem (pelne tlo zamiast
                        przezroczystego na podstronach z fotografia). Prog zostawiony
                        taki jak byl, zeby nie zmieniac wygladu strony glownej.
      header--hidden  - schowany przy przewijaniu w dol.
      header--hold    - wstrzymany przez ekran ladowania.
  */
  class StickyHeader extends HTMLElement {
    constructor() {
      super();

      const announcement = this.querySelector('.header__announcement');
      this.adjust = announcement ? announcement.offsetHeight : 0;
      this.isSticky = false;
      this.isHidden = false;
      this.ticking = false;

      window.addEventListener('scroll', () => this.requestUpdate(), { passive: true });
      window.addEventListener('resize', () => this.requestUpdate(), { passive: true });
      window.addEventListener('pageLoaderComplete', () => this.classList.remove('header--hold'));

      this.update();
    }

    requestUpdate() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.ticking = false;
        this.update();
      });
    }

    update() {
      if (window.lockHeader) return;

      const scroll = window.scrollY || document.documentElement.scrollTop || 0;
      const threshold = this.offsetHeight + this.adjust;

      const sticky = scroll > threshold;
      if (sticky !== this.isSticky) {
        this.isSticky = sticky;
        this.classList.toggle('header--sticky', sticky);
      }

      // Chowamy tylko przy zjezdzaniu i dopiero gdy naglowek zdazyl odjechac od gory,
      // zeby drobny ruch tuz pod krawedzia nie migal.
      const hidden = sticky && window.scrollDirection === 'down';
      if (hidden !== this.isHidden) {
        this.isHidden = hidden;
        this.classList.add('header--transition');
        this.classList.toggle('header--hidden', hidden);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);
}
